import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'

export default class Text extends React.Component {
  static propTypes = {
    field: PropTypes.object,
    menu: PropTypes.bool
  }

  getClases(){
    console.log("Obteniendo clases")
    let myClass = '';
    if(this.props.field.textSize) {
      if(this.props.field.textSize==='medium'){
        myClass = styles.medium
      } else if(this.props.field.textSize==='large'){
        myClass = styles.large
      }
    }
    myClass += ' ' + styles.container;
    console.log("La clase calculada es " + myClass)
    return myClass
  }

  renderName() {
    return (
      <div className={this.getClases()}>
        {this.props.field.name} {this.props.field.required ? '(Requerido)' : '(Opcional)'}
      </div>
    )
  }

  renderValidation() {
    return (
      <div className={this.getClases()}>
        {this.props.field.validation} {this.props.field.required ? '(Requerido)' : '(Opcional)'}
      </div>
    )
  }

  renderBlank() {
    return (
      <div className={this.getClases()}>
        Texto {this.props.field && this.props.field.required ? '(Requerido)' : '(Opcional)'}
      </div>
    )
  }

  renderHeader() {
    return <div className={styles.container}>Texto</div>
  }

  render() {
    console.log("Prepare template Field Text index");

    if (this.props.menu) return this.renderHeader()
    if (this.props.field && this.props.field.value && this.props.field.value.text) {
      return <div className={styles.container}>{this.props.field.value.text}</div>
    }
    if (this.props.field && this.props.field.name) return this.renderName()
    if (
      this.props.field &&
      this.props.field.validation &&
      this.props.field.validation !== 'ninguno'
    ) {
      return this.renderValidation()
    }
    if (!this.props.field) return this.renderBlank()
    if (!this.props.field.value) return this.renderBlank()
    if (!this.props.field.value.text) return this.renderBlank()
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Sign/PrepareTemplate/Field/Text/index.js